import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import BalanceOnHandViewInfoContainer from '../../impc-characteristics/boh-info/containers/BalanceOnHandViewInfoContainer';
import BalanceonHandRouteContainer from '../../impc-characteristics/boh-route/containers/BalanceonHandRouteContainer';
import BalanceOnHandThresholdsContainer from '../../impc-characteristics/boh-thresholds/containers/BalanceOnHandThresholdsContainer';
import BalanceOnHandPastInfoContainer from '../../impc-characteristics/boh-historic/containers/BalanceOnHandPastInfoContainer';

let defaultTab = 0;

function ImpcCharacteristicsTabsPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

ImpcCharacteristicsTabsPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    maxHeight: '330px',
  },
  tab: {
    '& .MuiBox-root': {
      padding: '5px',
    },
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultTab);

  const handleChange = (event, newValue) => {
    defaultTab = newValue;
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="fullWidth">
          <Tab label="BoH Info" {...a11yProps(0)} />
          <Tab label="BoH Thresholds" {...a11yProps(1)} />
          <Tab label="Routes" {...a11yProps(2)} />
          <Tab label="Historic BoH" {...a11yProps(3)} />
        </Tabs>
      </AppBar>
      <ImpcCharacteristicsTabsPanel value={value} index={0} classes={{ root: classes.tab }}>
        <BalanceOnHandViewInfoContainer />
      </ImpcCharacteristicsTabsPanel>
      <ImpcCharacteristicsTabsPanel value={value} index={1} classes={{ root: classes.tab }}>
        <BalanceOnHandThresholdsContainer />
      </ImpcCharacteristicsTabsPanel>
      <ImpcCharacteristicsTabsPanel value={value} index={2} classes={{ root: classes.tab }}>
        <BalanceonHandRouteContainer />
      </ImpcCharacteristicsTabsPanel>
      <ImpcCharacteristicsTabsPanel value={value} index={3} classes={{ root: classes.tab }}>
        <BalanceOnHandPastInfoContainer />
      </ImpcCharacteristicsTabsPanel>
    </div>
  );
}
